"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunchModal = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const useMissedPunchLockoutStatus_1 = require("../../../hooks/useMissedPunchLockoutStatus");
const useEditPunchLockoutStatus_1 = require("../../../hooks/useEditPunchLockoutStatus");
const PunchModalTypes_1 = require("../PunchModalTypes");
const taaConfigs_1 = require("../../../contexts/taaConfigs");
const logger_1 = require("../../../logger");
const usePunchModal = ({ associateInfo, ctkPolicy, currentSelectedDate, defaultTime, militaryTime, modalType, hasLimit, usageLocation }) => {
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const [selectedDate, setSelectedDate] = react_1.default.useState(currentSelectedDate);
    const [punchTime, setPunchTime] = react_1.default.useState(defaultTime);
    const [inputError, setInputError] = react_1.default.useState(false);
    const [inputErrorMessage, setInputErrorMessage] = react_1.default.useState('');
    const [useMilitaryTime, setUseMilitaryTime] = react_1.default.useState(militaryTime !== null && militaryTime !== void 0 ? militaryTime : true);
    const { isLoading: isMissedPunchLockoutStatusLoading, data: { associateAipLockoutStatus } = {}, error: missedPunchLockoutStatusError } = (0, useMissedPunchLockoutStatus_1.useMissedPunchLockoutStatus)({
        employeeId: associateInfo.employeeId,
        shouldFetch: hasLimit && modalType === PunchModalTypes_1.PunchModalType.MISSED_PUNCH,
        usageLocation
    });
    const { isLoading: isEditPunchLockoutStatusLoading, data: { editPunchLockoutStatus } = {}, error: editPunchLockoutStatusError } = (0, useEditPunchLockoutStatus_1.useEditPunchLockoutStatus)({
        employeeId: associateInfo.employeeId,
        shouldFetch: hasLimit && modalType === PunchModalTypes_1.PunchModalType.PUNCH_EDIT,
        usageLocation
    });
    const isLockoutStatusLoading = isMissedPunchLockoutStatusLoading || isEditPunchLockoutStatusLoading;
    const lockoutStatusError = hasLimit &&
        ((modalType === PunchModalTypes_1.PunchModalType.MISSED_PUNCH &&
            !!missedPunchLockoutStatusError) ||
            (modalType === PunchModalTypes_1.PunchModalType.PUNCH_EDIT &&
                !!editPunchLockoutStatusError));
    let lockoutStatus = {
        type: PunchModalTypes_1.LockoutStatusType.OK,
        message: null
    };
    let modalTitleText, modalMessageText, calendarTitleText, submitButtonText, submissionWarningText;
    switch (modalType) {
        case PunchModalTypes_1.PunchModalType.MISSED_PUNCH:
            modalTitleText = t('time_and_attendance_PunchModal_MissedPunch_title');
            modalMessageText = ctkPolicy
                ? t('time_and_attendance_PunchModal_MissedPunchCTKMessage')
                : null;
            calendarTitleText = t('time_and_attendance_PunchModal_MissedPunchDate');
            submitButtonText = ctkPolicy
                ? t('time_and_attendance_PunchModal_MissedPunchCTKSubmit')
                : t('time_and_attendance_PunchModal_Report');
            submissionWarningText = ctkPolicy
                ? null
                : t('time_and_attendance_PunchModal_MissedPunchSubmissionWarning');
            const missedPunchLockoutStatus = associateAipLockoutStatus === null || associateAipLockoutStatus === void 0 ? void 0 : associateAipLockoutStatus.associateAipLockoutStatus;
            if (missedPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.WARNING) {
                lockoutStatus = {
                    type: missedPunchLockoutStatus,
                    message: t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Warning')
                };
            }
            else if (missedPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.LOCKED_OUT) {
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.MISSED_PUNCH_LIMIT_LOCKOUT.COUNT,
                    dimensions
                });
                lockoutStatus = {
                    type: missedPunchLockoutStatus,
                    message: t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Block')
                };
            }
            break;
        case PunchModalTypes_1.PunchModalType.PUNCH_CORRECTION:
            modalTitleText = t('time_and_attendance_PunchModal_PunchCorrection_title');
            modalMessageText = t('time_and_attendance_PunchModal_PunchCorrectionsMessage');
            calendarTitleText = t('time_and_attendance_PunchModal_MissedPunchDate');
            submitButtonText = t('time_and_attendance_PunchModal_Report');
            submissionWarningText = t('time_and_attendance_PunchModal_PunchCorrectionsWarning');
            break;
        case PunchModalTypes_1.PunchModalType.PUNCH_EDIT:
            modalTitleText = t('time_and_attendance_PunchModal_PunchEdit_title');
            modalMessageText = null;
            calendarTitleText = t('time_and_attendance_PunchModal_PunchDate');
            submitButtonText = t('time_and_attendance_PunchModal_Edit');
            submissionWarningText = t('time_and_attendance_PunchModal_PunchEditSubmissionWarning');
            if (editPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.WARNING) {
                lockoutStatus = {
                    type: editPunchLockoutStatus,
                    message: t('time_and_attendance_PunchModal_PunchEditLockout_Warning')
                };
            }
            else if (editPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.LOCKED_OUT) {
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PUNCH_EDIT_LIMIT_LOCKOUT.COUNT,
                    dimensions
                });
                lockoutStatus = {
                    type: editPunchLockoutStatus,
                    message: t('time_and_attendance_PunchModal_PunchEditLockout_LockedOut')
                };
            }
            break;
        default:
            modalTitleText = null;
            modalMessageText = null;
            calendarTitleText = null;
            submitButtonText = null;
            lockoutStatus = {
                type: PunchModalTypes_1.LockoutStatusType.OK,
                message: null
            };
    }
    const timeInputLabelText = modalType === PunchModalTypes_1.PunchModalType.PUNCH_EDIT
        ? t('time_and_attendance_PunchModal_EditPunchTime')
        : t('time_and_attendance_PunchModal_MissedPunchTime');
    const toggleMilitaryTime = () => {
        setUseMilitaryTime(!useMilitaryTime);
        setPunchTime('');
    };
    return {
        modalTitleText,
        modalMessageText,
        calendarTitleText,
        timeInputLabelText,
        submissionWarningText,
        submitButtonText,
        isLockoutStatusLoading,
        lockoutStatusError,
        lockoutStatus,
        selectedDate,
        setSelectedDate,
        punchTime,
        setPunchTime,
        inputError,
        setInputError,
        inputErrorMessage,
        setInputErrorMessage,
        useMilitaryTime,
        toggleMilitaryTime
    };
};
exports.usePunchModal = usePunchModal;
